import React from "react";
import { useTranslation } from "next-i18next";

import styles from "./reader-top-panel.module.scss";

const ReaderTopPanelLoader = () => {
  const { t } = useTranslation();
  return <div className={styles["reader-top-panel"]}>{t("loading")}…</div>;
};

export default ReaderTopPanelLoader;
